import { DataAccessRequestControls } from '../../../../components/DataAccessRequest/DataAccessRequestControls/DataAccessRequestControls';
import type { INotificationActionsDataAccessRequestProps } from '../../types';

export function DataAccessRequestActions({
	notification,
}: INotificationActionsDataAccessRequestProps) {
	const canShowButtons = ['data_access_request_created'].includes(
		notification.event
	);

	if (!notification.resource_id || !canShowButtons) {
		return null;
	}

	return (
		<DataAccessRequestControls requestId={notification.resource_id as string} />
	);
}
